import 'swiper/css';
import 'swiper/css/pagination';

import { useTheme } from '@emotion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMediaQuery } from '@mui/material';
import PropTypes from 'prop-types';
import * as React from 'react';
import * as reactIntl from 'react-intl';
import { FormattedMessage } from 'react-intl';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { TrlNavigationFooter, TrlTabContainer } from '»components/molecules';
import { TrlCardStockExchange } from '»components/molecules/TrlCard';
import { TrlChart } from '»components/molecules/TrlChart';
import {
  useCurrentPage,
  useIsTitleNegotiable,
  useNegModalContext,
} from '»utils/customHooks';

import { TrlInsertOrderModal } from '../../templates/TrlInsertOrder';
import {
  ButtonsWrapper,
  LeafListItemButtonMobileStyled,
  LeafListItemTextMobileStyled,
  Wrapper,
} from './TrlMarketDetails.styles';

export const TrlMarketDetails = ({
  selectedTitle,
  swiperSlides,
  negotiationButtons,
}) => {
  const theme = useTheme();
  const isAbove700 = useMediaQuery(theme.breakpoints.up('md'));
  const intl = reactIntl.useIntl();

  const { isFunds } = useCurrentPage();

  const { openInsertOrderModal } = useNegModalContext();

  const isTitleNegotiable = useIsTitleNegotiable({
    isMarketPrimaryScreen: false,
    isFundsPrimaryScreen: false,
    canTrade: selectedTitle.canTrade,
  });

  const getButtonContent = (message, icon) => {
    if (isAbove700) return <FormattedMessage id={message} />;

    return <FontAwesomeIcon icon={icon} />;
  };

  return (
    <Wrapper>
      <TrlInsertOrderModal />
      <TrlCardStockExchange data={selectedTitle} isCardMobileDetails />
      <TrlChart isFunds={isFunds} />
      <div className="swipe">
        <Swiper
          loop
          pagination={{
            clickable: true,
          }}
          modules={[Pagination]}
          className="mySwiper"
        >
          {swiperSlides.map((slide, index) => (
            <SwiperSlide
              key={slide.label}
              style={{
                backgroundColor: theme.palette.colors.primaryBackground,
              }}
            >
              <TrlTabContainer
                value={0}
                variant="innerTabs"
                stockExchangeDetails
                stockExchangeDetailsCurrentSlide={index}
                tabs={[
                  {
                    label: intl.formatMessage({
                      id: slide.label,
                    }),
                  },
                ]}
              />

              {slide.component}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <TrlNavigationFooter>
        <ButtonsWrapper>
          {negotiationButtons.map((button) => (
            <LeafListItemButtonMobileStyled
              key={button.id}
              id={button.id}
              onClick={() => {
                openInsertOrderModal(button.operationType);
              }}
              disabled={!isTitleNegotiable}
            >
              <LeafListItemTextMobileStyled
                primary={getButtonContent(button.label, button.icon)}
              />
            </LeafListItemButtonMobileStyled>
          ))}
        </ButtonsWrapper>
      </TrlNavigationFooter>
    </Wrapper>
  );
};

TrlMarketDetails.propTypes = {
  selectedTitle: PropTypes.object.isRequired,
  swiperSlides: PropTypes.array.isRequired,
  negotiationButtons: PropTypes.array.isRequired,
};
